import React from 'react';
import {Field, reduxForm} from 'redux-form'
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DoneIcon from 'material-ui/svg-icons/action/done';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import * as colors from 'material-ui/styles/colors';

import FormText from '../../../components/FormText'
import FormSelect from '../../../components/FormSelect'


class CostMasterForm extends React.Component {

  render() {

    const {
      error,
      reset,
      handleSubmit,
      initialValues,
      onFormRegistClick,
      onFormSearchClick,
      onFormResetClick,
      onLocalStorageSave
     } = this.props

    return (

      <form onSubmit={handleSubmit(() => {})}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}
        
          <div className="row">

            <div className="col-3">

              <Field
                name="kind"
                component={FormSelect}
                style={{ width: '100%' }}
                label="費用種別"
              >
                <MenuItem value={1} primaryText="材料費" />
                <MenuItem value={2} primaryText="外注費" />
                <MenuItem value={3} primaryText="労務費" />
                <MenuItem value={4} primaryText="経費" />
             </Field>

            </div>

            <div className="col-4">

              <Field
                name="name"
                component={FormText}
                label="費用"
                style={{ width: '100%' }}
                value={initialValues.name}
              />

            </div>

          </div>

          <div className="row" style={{marginTop: 20}}>

            <div className="col-6" style={{paddingTop: 5, display: 'flex', justifyContent:'flex-start'}}>

              <FlatButton
                label="登録"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px', marginRight: '20px' }}
                backgroundColor={colors.cyan700}
                hoverColor={colors.cyan900}
                icon={<DoneIcon color={colors.white} />}
                onClick={handleSubmit(onFormRegistClick)}
              />

              {initialValues.id && 

                <FlatButton
                  label="編集モード終了"
                  primary={true}
                  labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                  style={{ height: '40px', width: '140px', marginRight: '20px' }}
                  onClick={onFormResetClick}
                />
              }

            </div>

            <div className="col-6" style={{textAlign: 'right'}}>
              <FlatButton
                label="クリア"
                primary={true}
                labelStyle={{ color: colors.grey500, lineHeight: '40px' }}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                onClick={() => {
                  reset()
                  onFormResetClick()
                }}
              />


              <FlatButton
                label="固定"
                labelPosition="before"
                primary={true}
                labelStyle={{color: colors.white, lineHeight: '40px'}}
                style={{height: '40px', width: '100px', marginRight: '20px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey700}
                icon={<LockIcon color={colors.white}/>}
                onClick={handleSubmit(onLocalStorageSave)}
              />

              <FlatButton
                label="検索"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '100px' }}
                backgroundColor={colors.blue500}
                hoverColor={colors.blue700}
                icon={<SearchIcon color={colors.white} />}
                onClick={handleSubmit(onFormSearchClick)}
              />

            </div>
          </div>

      </form>

    )

  }

}

CostMasterForm = reduxForm({
  form: 'costMasterForm',
  enableReinitialize: true,
})(CostMasterForm)

export default CostMasterForm




// WEBPACK FOOTER //
// ./src/containers/master/cost/CostMasterForm.js